///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2002-2025, Open Design Alliance (the "Alliance").
// All rights reserved.
//
// This software and its documentation and related materials are owned by
// the Alliance. The software may only be incorporated into application
// programs owned by members of the Alliance, subject to a signed
// Membership Agreement and Supplemental Software License Agreement with the
// Alliance. The structure and organization of this software are the valuable
// trade secrets of the Alliance and its suppliers. The software is also
// protected by copyright law and international treaty provisions. Application
// programs incorporating this software must include the following statement
// with their copyright notices:
//
//   This application incorporates Open Design Alliance software pursuant to a
//   license agreement with Open Design Alliance.
//   Open Design Alliance Copyright (C) 2002-2025 by Open Design Alliance.
//   All rights reserved.
//
// By use of this software, its documentation or related materials, you
// acknowledge and accept the above terms.
///////////////////////////////////////////////////////////////////////////////

import { Box3 } from "three";

import { IComponent } from "@inweb/viewer-core";
import type { Viewer } from "../Viewer";

export class ExtentsComponent implements IComponent {
  private viewer: Viewer;

  constructor(viewer: Viewer) {
    this.viewer = viewer;
    this.viewer.addEventListener("databasechunk", this.syncExtents);
    this.viewer.addEventListener("clear", this.syncExtents);
    this.viewer.on("explode", this.syncExtents);
    this.viewer.on("hide", this.syncExtents);
    this.viewer.on("isolate", this.syncExtents);
    this.viewer.on("show", this.syncExtents);
    this.viewer.on("showall", this.syncExtents);
  }

  dispose() {
    this.viewer.removeEventListener("databasechunk", this.syncExtents);
    this.viewer.removeEventListener("clear", this.syncExtents);
    this.viewer.off("explode", this.syncExtents);
    this.viewer.off("hide", this.syncExtents);
    this.viewer.off("isolate", this.syncExtents);
    this.viewer.off("show", this.syncExtents);
    this.viewer.off("showall", this.syncExtents);
  }

  syncExtents = (event) => {
    const extents = new Box3();
    this.viewer.models.forEach((model) => model.getExtents(extents));
    this.viewer.extents.copy(extents);

    if (event.type !== "databasechunk" && event.target !== "clear") return;
    if (this.viewer.models.length > 1) return; // do not change target in assembly mode

    this.viewer.extents.getCenter(this.viewer.target);
  };
}
